import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  currentLanguage: string = localStorage.getItem("lan") == "es" ? "spanish" : "english";
  startuplanguage = new Subject();
  private language = new BehaviorSubject(this.currentLanguage);
  constructor() {}
  setLanguage(item: any): void {
    this.language.next(item);
    this.startuplanguage.next(item);
  }
  public getCurrentLanguage(): Observable<string> {
    return this.language.asObservable();
  }
  getStartupLanguage(): Observable<unknown> {
    return this.startuplanguage.asObservable();
  }
}
